import Loader from "../../../atoms/Loader/Loader";

interface Props {
  userdata: any;
  filteredValue: [];
  status: string;
  clickFilterStatus?: boolean;
  clickFilterSearch?: boolean;
  isLoading: boolean;
}
const SearchHelper = (props: Props) => {
  function Render() {
    if (props.isLoading) {
      return <Loader />;
    } else {
      if (props.userdata?.totalRecords === 0) {
        return <div className="no-res">No Results Found</div>;
      } else {
        if (props.clickFilterStatus) {
          if (props.userdata && props.userdata?.totalRecords === 0) {
            return <div className="no-res">No Results Found</div>;
          }
        }

        if (props.clickFilterSearch) {
          if (props.userdata && props.userdata.totalRecords === 0) {
            return <div className="no-res">No Results Found</div>;
          }
        }

        if (!props.clickFilterStatus && !props.clickFilterSearch) {
          return <Loader />;
        }
      }
    }
  }
  return <div>{Render()}</div>;
};

export default SearchHelper;
